import React, { useEffect } from "react";

import "./styles.css";

interface props {
    data: any;
    index: string;
    onClick: (index: string) => void;
    activeTabId: string;
}
function LevelList(props: props) {
  useEffect(()=>{
    console.log("data: ", props.data);
    
  },[]);
  const Clicked = () => {
    props.onClick(props.index);
  };

  return (
    <li key={props.index} style={{ listStyle: "none", textAlign: "left" }}>
      <button
        className="section__Jobs-buttonCompany"
        onClick={Clicked}
        style={
          props.activeTabId === props.index
            ? { color: "#0773BB", backgroundColor: "#F0F0F0", fontWeight: "bold" }
            : { color: "#353935" }
        }
      >
        {props.data}
      </button>
    </li>
  );
}

export default LevelList;
